module.exports = __webpack_public_path__ + "img/map2.e257fa33.svg";